import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NonUniqueNameWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.product.validation.name.non-unique');
    }
}
